import api from './api';
import { Subdivision, CreateSubdivisionData } from '../types/subdivision';

interface PaginationParams {
  page?: number;
  limit?: number;
  search?: string;
  builderId?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

interface SubdivisionsResponse {
  subdivisions: Subdivision[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

interface SubdivisionResponse {
  subdivision: Subdivision;
}

export const subdivisionService = {
  // Get all subdivisions for a workspace
  getAll: async (workspaceId: string, params?: PaginationParams): Promise<SubdivisionsResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/subdivisions`, { params });
    return response.data;
  },

  // Get subdivision by ID
  getById: async (workspaceId: string, subdivisionId: string): Promise<SubdivisionResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/subdivisions/${subdivisionId}`);
    return response.data;
  },

  // Create subdivision
  create: async (workspaceId: string, data: CreateSubdivisionData): Promise<SubdivisionResponse> => {
    const response = await api.post(`/workspaces/${workspaceId}/subdivisions`, data);
    return response.data;
  },

  // Update subdivision
  update: async (
    workspaceId: string,
    subdivisionId: string,
    data: Partial<CreateSubdivisionData>
  ): Promise<SubdivisionResponse> => {
    const response = await api.put(`/workspaces/${workspaceId}/subdivisions/${subdivisionId}`, data);
    return response.data;
  },

  // Delete subdivision
  delete: async (workspaceId: string, subdivisionId: string): Promise<{ message: string }> => {
    const response = await api.delete(`/workspaces/${workspaceId}/subdivisions/${subdivisionId}`);
    return response.data;
  },

  // Get projects for a subdivision
  getProjects: async (workspaceId: string, subdivisionId: string): Promise<any> => {
    const response = await api.get(`/workspaces/${workspaceId}/subdivisions/${subdivisionId}/projects`);
    return response.data;
  }
};
